export default __webpack_public_path__ + "static/media/step - 8.91f4bd9f.jpeg";